import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../apiWrapper";

// 学年（1〜12の数値）を「小1」「中1」「高1」などの表記に変換する関数
const formatGrade = (grade) => {
  const num = Number(grade);
  if (!num) return "";
  if (num >= 1 && num <= 6) return `小${num}`;
  if (num >= 7 && num <= 9) return `中${num - 6}`;
  if (num >= 10 && num <= 12) return `高${num - 9}`;
  return "";
};

const TodayStudentSelection = ({ setSelectedStudents }) => {
  const [students, setStudents] = useState([]);
  const [tempSelectedStudents, setTempSelectedStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ユーザー情報が取得できたら、JWTに基づいて担当生徒情報を取得
  useEffect(() => {
    const fetchStudentsData = async () => {
      setLoading(true);
      try {
        // teacherStudentsエンドポイントはJWTからteacheridとschoolidを利用するため、パラメータは不要
        const data = await getRequest("teacherStudents");
        if (data) {
          setStudents(data.students);
  
          // data.selectedStudentsからdata.studentsに存在しないものを除外する
          const filteredSelectedStudents = (data.selectedStudents || []).filter(selected =>
            data.students.some(student => student.studentid === selected.studentid)
          );
          setTempSelectedStudents(filteredSelectedStudents);
  
          console.log("✅ APIから取得した担当生徒情報:", data.students);
          console.log("✅ APIから取得した選択済み生徒情報:", filteredSelectedStudents);
        } else {
          console.error("❌ APIからのデータ取得に失敗しました");
        }
      } catch (error) {
        console.error("❌ 生徒データ取得エラー:", error);
      }
      setLoading(false);
    };
  
    fetchStudentsData();
  }, []);
  

  const handleSelectStudent = (student) => {
    setTempSelectedStudents((prev) =>
      prev.find((s) => s.studentid === student.studentid)
        ? prev.filter((s) => s.studentid !== student.studentid)
        : prev.length < 5
          ? [...prev, student]
          : prev
    );
  };

  const handleConfirmSelection = async () => {
    try {
      setLoading(true);
      // teacheridやschoolidはサーバー側でJWTから取得するので、bodyは選択された生徒情報のみ送信
      const response = await postRequest("selectedStudents", {
        students: tempSelectedStudents,
      });
      const result = await response.json();
      if (response.ok) {
        console.log("✅ 選択更新成功:", result);
        setSelectedStudents(tempSelectedStudents);
        sessionStorage.setItem("selectedStudents", JSON.stringify(tempSelectedStudents));
        setLoading(false);
        navigate("/report");
      } else {
        console.error("❌ 更新エラー:", result);
        setLoading(false);
      }
    } catch (error) {
      console.error("❌ API更新エラー:", error);
      setLoading(false);
    }
  };

  return (
    <div className="p-6 pt-20">
      <h2 className="text-xl font-bold mb-4">
        今日担当する生徒を選んでください（最大5名）
      </h2>
      {loading ? (
        <p>データを取得中...</p>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {students.map((student) => {
            const isSelected = tempSelectedStudents.some(
              (s) => s.studentid === student.studentid
            );
            const shortGrade = formatGrade(student.grade);

            return (
              <button
                key={student.studentid}
                onClick={() => handleSelectStudent(student)}
                className={`p-3 rounded-lg border flex items-center justify-between ${
                  isSelected
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                <span className="font-medium">
                  {student.name}
                  {shortGrade && `（${shortGrade}）`}
                </span>
              </button>
            );
          })}
        </div>
      )}
      <button
        onClick={handleConfirmSelection}
        className="mt-4 w-full bg-green-500 text-white py-2 rounded-lg"
        disabled={loading || tempSelectedStudents.length === 0}
      >
        {loading ? "更新中..." : "選択完了"}
      </button>
    </div>
  );
};

export default TodayStudentSelection;
